import { Outlet } from "react-router-dom";
import style from "./AuthLayout.module.scss";

export function AuthLayout() {
    return (
        <div id="layout" className={style.layout}>
            <div  className={style.zoom}>
                <div id="zoom" className={style.limit}>
                    <div className={style.logo}>
                        <img src="/image/logo.svg" alt="logo" />
                        <p className={style.name}>rocketproxy</p>
                    </div>
                    <div className={style.container}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    )
}